export type UserInfoAPIType = {
  name?: string;
  email?: string;
  institution?: string;
  notes?: any;
};

export type UserInfoLocalStorageType = {
  name?: string;
  email?: string;
  institution?: string;
  img?: string;
  featureSet?: string;
  featureFlags?: any;
  payment_status?: 'overdue' | 'freetrial_expired';
  user_metrics?: any;
  gamification?: any;
  referral_info?: any;
  user_id?: string;
  email_verified?: any;
  group_ids?: string[];
  group_user_roles?: string[];
};

export const getUserInfoFromLocalStorage = (): UserInfoLocalStorageType | undefined => {
  const userInfo = localStorage.getItem('userInfo');
  if (userInfo) {
    return JSON.parse(userInfo) as UserInfoLocalStorageType;
  } else {
    return undefined;
  }
};

export const saveUserInfoToLocalStorage = (userInfo: UserInfoLocalStorageType, user: any) => {
  localStorage.setItem('userInfo', JSON.stringify({ ...userInfo, img: user?.picture || '' }));
};

export const updateUserInfoToLocalStorage = (userInfo: UserInfoLocalStorageType) => {
  const current = getUserInfoFromLocalStorage();
  const newUserInfo = {
    ...current,
    email: userInfo?.email,
    name: userInfo?.name,
    institution: userInfo?.institution,
  };
  localStorage.setItem('userInfo', JSON.stringify(newUserInfo));
};

/**
 * Saves the current URL (pathname + search + hash) to localStorage
 * so that after login, users are redirected back to where they were going.
 *
 * This is used before redirecting to Auth0 login.
 */
export const saveReturnToUrl = () => {
  // Get the full path including pathname, search params, and hash
  const returnTo = window.location.pathname + window.location.search + window.location.hash;

  // Only save if it's not already the root or callback
  if (returnTo !== '/' && !returnTo.startsWith('/callback')) {
    localStorage.setItem('returnTo', returnTo);
  }
};

/**
 * Gets the saved returnTo URL from localStorage.
 */
export const getReturnToUrl = (): string | null => {
  return localStorage.getItem('returnTo');
};

/**
 * Clears the saved returnTo URL from localStorage.
 */
export const clearReturnToUrl = () => {
  localStorage.removeItem('returnTo');
};
